import { RequestResults } from "../../common/RequestStatus";

export interface IAuthState {
  authStatus: RequestResults;
  authenticated: boolean;
  userAuthInfo: ILoginResponse | null;
}

export interface PermissionConfig {
  id: string;
  configName: string;
  configKey: string;
  configType: number;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface IUserRole {
  id: string;
  name: string;
  description: string;
  isActive: boolean;
  permissionConfigs: PermissionConfig[];
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ILoginResponse {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  status: number;
  accessToken?: string;
  refreshToken?: string;
  loginAt: string;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  role: IUserRole;
}
export interface IAuthResponse {
  success: boolean;
  statusCode: number;
  message: string;
}

export const PermissionConfigFor = {
  Config: 1,
  Report: 2,
  PaymentManagement: 3,
  MenuVisibility: 4,
  SystemManagement: 5,
  StatusPermissions: 6,
};
